import React from 'react';
import { Helmet } from 'react-helmet-async';

const SEO = ({ 
  title = "Your Trusted Partner in Europe", 
  description = "FLYVIA - Professional services for residency, company formation, and relocation to Spain and Europe.", 
  keywords = "FlyVia, Spain residency, Schengen visa, company formation, move to Europe", 
  schemaMarkup 
}) => {
  const fullTitle = `${title} | FLYVIA`;
  
  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="keywords" content={keywords} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:site_name" content="FLYVIA" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />

      {/* Schema Markup */}
      {schemaMarkup && (
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
